import { render } from "./ModalWindow.vue?vue&type=template&id=a60dcede&scoped=true&ts=true"
import script from "./ModalWindow.vue?vue&type=script&lang=ts"
export * from "./ModalWindow.vue?vue&type=script&lang=ts"

import "./ModalWindow.vue?vue&type=style&index=0&id=a60dcede&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a60dcede"]])

export default __exports__